// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__VrNUJ","skeleton-loading":"style_skeleton-loading__TgaYX","card_image":"style_card_image__Arhjc","shimmer":"style_shimmer__2ushK"};